import {ReviewsApiContainer} from '@containers/CustomerReviews/api';
import {Formik} from 'formik';
import invoke from 'lodash.invoke';
import {trimFormData} from '@ultradent/utilities/Strings'
import {Button, Message, Textarea} from '@ultradent/components';
import Icon from '@components/common/Icon';

const DialogRespondReview = ( props, context ) => {

    const closeModal = () => invoke( context, 'onClose' );
    const {id, comment} = props.submitData;

    return (
        <ReviewsApiContainer render={( {updateReviewResponse: {mutation, result}} ) =>
            <Formik
                validate={formData => {
                    const errors = {};
                    const {comment} = trimFormData( formData );

                    if ( !comment ) {
                        errors.comment = 'A message is required'
                    }
                    else if ( comment.length < 4 ) {
                        errors.comment = 'This message is too short'
                    }

                    if ( comment.length > 2500 ) {
                        errors.comment =
                            `This message can only be approx. 2500 characters or less (currently ${comment.length})`
                    }

                    return errors;
                }}
                initialValues={{comment}}
                onSubmit={values => {
                    mutation( {
                        variables: {
                            input: {id, ...trimFormData( values )}
                        }
                    } ).then( closeModal )
                }}
                render={( {values, errors, touched, handleSubmit, handleChange} ) => (
                    <div>
                        <p className="mb-2 px-4 py-2 text-sm flex items-center bg-moon-grey rounded">
                            <Icon.logo name="upi-logo-short" color="brand" className="mr-2 text-3xl"/>
                            <span><strong>Important!</strong> This will be posted to ultradent.com for <b>all customers</b> see.</span>
                        </p>
                        <div>
                        <Textarea
                            id="comment"
                            label="Leave your response to the customer review"
                            onChange={handleChange}
                            isFocused={true}
                            error={touched.comment && errors.comment}
                            value={values.comment}
                            inputClassName="w-full h-32"
                            className="mt-2"/>

                            <div className="button-bar mt-8">
                                <Button secondary onClick={closeModal}>Cancel</Button>
                                <Button primary loading={result.loading} onClick={handleSubmit}>Submit</Button>
                            </div>
                        </div>
                        {result.error &&
                            <Message notice>There was an error submitting this request, please try again.</Message>
                        }
                    </div>
                )}
            />
        }/>
    );
}

export default DialogRespondReview;